import React, {useState , useEffect} from 'react';
import { Col, Container, Row , Input} from 'reactstrap';
import { useDispatch , useSelector } from 'react-redux';
import { set_bread_crum } from '../../slices/header/reducer';
import Workflow_GridView from './Workflow_GridView';
import Workflow_ListView from './Workflow_ListView';
import Create_New_Dashboard from '../../Components/Common/CustomModal/Create_New_Dashboard';
import Create_New_WorkFlow_Dashboard from '../../Components/Common/CustomModal/Create_New_WorkFlow_Dashboard';
import { DELETE_WORKFLOW, FETCH_WORKFLOW_CATEGORY_LIST, FETCH_WORKFLOW_LIST, group_list } from '../../slices/thunks';
import Workflow_Pagination from './Workflow_Pagination';
import config from '../../config';
import Loader from '../../Components/Common/Loader';
import { close_confirm_modal, open_confirm_modal } from '../../slices/Confirm_Modal/reducer';
import { waitForDecision } from '../../utility/wait_for_confirmation';


const Dashboard = () => {

    const dispatch = useDispatch()
    const group_details = useSelector((state)=>state.Group_List)
    const [activeView, setActiveView] = useState("grid");
    const [isActive, setIsActive] = useState(false);
    const {workflow_list , workflow_listing_loader , workflow_category} = useSelector((state)=>{
       return state.WorkFlowBuilder
    })


    const [filter, setfilter] = useState({
   "page": 1,
  "per_page": config.general_config.PER_PAGE_CONTENT,
  "Workflow_Title": "",
  "Group_ID": null,
  "Type": "",
  "Category": "",
  "Created_By": "",
  "sort_by": "Updated_At",
  "sort_order": "DESC"
    })
    const handleButtonClick = (view) => {
    setActiveView(view);
    };

        useEffect(()=>{
        dispatch(set_bread_crum({ title:"Workflow Dashboard"  , pageTitle:"Dashboard"  }))

        return ()=>{
        dispatch(set_bread_crum({ title:""  , pageTitle:""  }))
            
        }
        },[])

        useEffect(() => {
           dispatch(FETCH_WORKFLOW_LIST())
           dispatch(FETCH_WORKFLOW_CATEGORY_LIST())
            dispatch(group_list({ page:1 , per_page:1000 }))
        }, [])


    const onPageChange = (page_number)=>{
    let filter_temp = filter
    filter_temp.page=Number.parseInt(page_number)
    setfilter(filter_temp)
   dispatch(FETCH_WORKFLOW_LIST(filter_temp))
    }



    const onChange_sort_by_search_titles = (e) => {
        let filter_temp = filter
        if (e.target.value === " "){
         
          filter_temp.Workflow_Title = null;
     
          
        }
        else{
        
         
         filter_temp.Workflow_Title = e.target.value;
    
      
        }
    
        filter_temp.page=1
        setfilter(filter_temp)
     
          dispatch(FETCH_WORKFLOW_LIST(filter_temp))
    
      }

     const onChange_sort_by_group = (e) => {
        let filter_temp = filter
        if (e.target.value === " "){
         
          filter_temp.Group_ID = null;
     
          
        }
        else{
        
         
         filter_temp.Group_ID = e.target.value;
    
      
        }
    
        filter_temp.page=1
        setfilter(filter_temp)
     
        dispatch(FETCH_WORKFLOW_LIST(filter_temp))
      }


        const onChange_sort_by = (e) => {
          let filter_temp = filter
          if (e.target.value === " "){
           
            filter_temp.sort_by_latest_use = 0;
       
            
          }
          else{
          
           
           filter_temp.sort_by_latest_use = e.target.value;
      
        
          }
      
          filter_temp.page=1
          setfilter(filter_temp)
       
            dispatch(bot_list(filter_temp))
        }

      const onChange_latest = (e) => {
          let filter_temp = filter
          if (e.target.value === 1){
           
            filter_temp.sort_order = 'DESC';
       
            
          }
          else{
          
           
           filter_temp.sort_order = 'ASC';
      
        
          }
      
          filter_temp.page=1
          setfilter(filter_temp)
       
            dispatch(FETCH_WORKFLOW_LIST(filter_temp))
        }


  const delete_workflow = async (workflow_id)=>{
    dispatch(open_confirm_modal("Are you sure you want to delete this workflow ."))
    const decision = await waitForDecision()
    if(decision){
      dispatch(DELETE_WORKFLOW({workflow_id}))
    }
     dispatch(close_confirm_modal())
  }
    
        

  return (
    <>
    <React.Fragment>
            <div className="page-content pt-10 chartdashboard">  
               <Container fluid>
                 <Row>
                    <Col xl={3}>
                        <div className="wrap_bot_buttons d-flex justify-content-between align-items-center mb-3">
                            <div className="switch_view ">                
                                <button
                                className={`btn ${activeView === "grid" ? "Active" : ""}`}
                                onClick={() => handleButtonClick("grid")}
                            >
                                <i className="mdi mdi-apps"></i>
                            </button>
                                <button
                                className={`btn ${activeView === "list" ? "Active" : ""}`}
                                onClick={() => handleButtonClick("list")}
                            >
                                <i className="mdi mdi-format-align-justify" />
                            </button>
                            </div>
                        </div>
                    </Col>
                    <Col xl={9} className={isActive ? 'active-div' : 'dactive-div'}>
                <div className="filter_or_sort mb-3">
                    
                    <div className="input-group">
                        <Input onChange={onChange_sort_by_search_titles} value={filter.Workflow_Title} type="text" className="form-control h-40" placeholder="Search Workflow title" aria-label="Recipient's username with two button addons" />
                        <button className="btn btn-secondary padd_10" type="button"><i className="bx bx-search fs-20" /></button>
                    </div>
                      <div>
                       <select onChange={onChange_sort_by_group} className="form-select" aria-label="Default select example">
                            <option value={" "}>Filter by group</option>
                            {
                              group_details.groupList.map((ele, i)=>{
                                   return <option key={i} value={ele.Group_ID}>{ele.Group_Name}</option>
                              })
                            }
                           
                        </select>
                        </div>
                        <div>
                        <select className="form-select" aria-label="Default select example">
                            <option value={""} >Filter by category                             
                            </option>
                            {
                              workflow_category.map((ele)=>{
                                return <option value={""} >{ele.Workflow_Category}</option>
                              })
                            }
                            
                        </select>
                        </div>
                        <div>
                        <select onChange={onChange_latest} className="form-select" aria-label="Default select example">
                            <option value={1} >Sort by latest use                            
                            </option>
                            <option value={0} >Sort by oldest use                            
                            </option>
                        </select>
                        </div>
                        <div className="d-grid gap-2">
                             <Create_New_WorkFlow_Dashboard />
                        </div>                        
                    
                </div>
            </Col>
                    
                 </Row>
                 {workflow_listing_loader ? <Loader/>:<Row>
                    <Col>
                        {activeView === "list" ? (
                          <>
                          
                         <Workflow_ListView  delete_workflow={delete_workflow}/>
                            
                          </>
                        ) : (
                          <>
                      <Workflow_GridView delete_workflow={delete_workflow} />
                          
                        
                          </>
                        )}
                    </Col>
                 </Row>}
                 <Row>
                    <Col>
                    <Workflow_Pagination onPageChange={onPageChange} total_pages={workflow_list?.total_pages} current_page={workflow_list?.current_page}  />
                    </Col>
                 </Row>
               </Container>
            </div>
        </React.Fragment>  
    </>
  )
}

export default Dashboard